import React from 'react';
import { styled } from 'linaria/react';
import PaginationContext from '@jetshop/core/components/Pagination/PaginationContext';
import formatMessage from '@jetshop/intl';
import qs from 'qs';
import { useLocation } from 'react-router';
import { theme } from '../../Theming/Theming';
import { getFontSize } from '../../Theming/helpers';

const Wrapper = styled('div')`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  border-top: 1px solid #e8e8e8;
  border-bottom: 1px solid #e8e8e8;
  padding: 1rem 0;
`;

const PrevButton = styled('a')`
  text-transform: uppercase;
  font-family: ${theme.button.fontFamily};
  font-weight: ${theme.button.fontWeight};
  text-transform: ${theme.button.textTransform};
  ${getFontSize(theme.button.fontSize)};
  &[data-disabled='true'] {
    color: #777;
    cursor: no-drop;
  }
`;
const NextButton = styled(PrevButton)``;
const PageControlWrapper = styled('div')``;
const Page = styled('a')`
  font-family: ${theme.button.fontFamily};
  font-weight: ${theme.button.fontWeight};
  text-transform: ${theme.button.textTransform};
  font-size: 1rem;
  border-bottom: 1px solid #fff;
  padding: 5px;
  margin: 0 5px;
  &[data-selected='true'] {
    border-color: #333;
  }
`;

function getPageUrl(location, queryParam, page) {
  const currentLocation = qs.parse(
    typeof window === 'undefined' ? location.search : window.location.search,
    {
      ignoreQueryPrefix: true
    }
  );
  const url =
    location.pathname +
    qs.stringify(
      Object.assign(Object.assign({}, currentLocation), {
        [queryParam]: page
      }),
      { addQueryPrefix: true, encodeValuesOnly: true, skipNulls: true }
    );
  return url;
}

const PageControl = ({
  totalPages,
  currentPage,
  goToPage,
  location,
  queryParam
}) => {
  //CREATE ARRAY WITH PAGE NUMBERS (1 TO TOTALPAGES)
  const indexArray = Array.from(Array(totalPages), (e, i) => i + 1);
  return (
    <PageControlWrapper>
      {indexArray.map(page => {
        return (
          <Page
            key={page}
            href={getPageUrl(location, queryParam, page)}
            onClick={e => {
              e.preventDefault();
              goToPage(page);
            }}
            data-selected={currentPage === page ? true : null}
          >
            {page}
          </Page>
        );
      })}
    </PageControlWrapper>
  );
};

export const PaginationWrapper = ({
  prevPage,
  nextPage,
  currentPage,
  totalPages,
  isFirstPage,
  isLastPage,
  hasPages,
  goToPage,
  className = ''
}) => {
  const location = useLocation();
  const { queryParam } = React.useContext(PaginationContext);

  return hasPages && !isNaN(totalPages) ? (
    <Wrapper className={className}>
      <PrevButton
        href={getPageUrl(
          location,
          queryParam,
          isFirstPage ? currentPage : currentPage - 1
        )}
        onClick={e => {
          e.preventDefault();
          prevPage();
        }}
        data-disabled={isFirstPage ? true : null}
      >
        {formatMessage('Prev')}
      </PrevButton>
      <PageControl
        totalPages={totalPages}
        currentPage={currentPage}
        goToPage={goToPage}
        location={location}
        queryParam={queryParam}
      />
      <NextButton
        href={getPageUrl(
          location,
          queryParam,
          isLastPage ? currentPage : currentPage + 1
        )}
        onClick={e => {
          e.preventDefault();
          nextPage();
        }}
        data-disabled={isLastPage ? true : null}
      >
        {formatMessage('Next')}
      </NextButton>
    </Wrapper>
  ) : null;
};
